import { Position } from "../../foundation/api/model";

export function snapToGrid(grid: [number, number], position: Position, algorithm: "round" | "floor" = "round"): [number, number] {
    const x = Math[algorithm](position.x / grid[0]) * grid[0];
    const y = Math[algorithm](position.y / grid[1]) * grid[1];

    return [x, y];
}
